/* @flow */

import React from 'react'
import NavigationButtons from 'atpjs/components/navigation_buttons'
import { nonEmptyString } from 'atpjs/validation/validators'
import i18n from 'atpjs/helpers/i18n'
import Step from 'tve/views/step'
import Application from 'tve/components/application'
import Navigation from 'tve/components/navigation'
import { BigOptionRadio } from 'tve/components/forms/big_option'

import type { PrefixType } from 'atpjs/helpers/i18n'

const t = i18n.prefix(['customerType'])

class CustomerType extends Step {
  sendData = false

  constructor(props) {
    super(props)
    this.customerTypeValues = [
      {
        label: i18n.trans(['options', 'customerType', 'private']),
        value: 'private',
        icon: 'client-type-private'
      },
      {
        label: i18n.trans(['options', 'customerType', 'corporate']),
        value: 'corporate',
        icon: 'client-type-business'
      }
    ]
  }

  validations(_trans: PrefixType) {
    return {
      customerType: nonEmptyString()
    }
  }

  render() {
    const inputSetProps = this.inputSetProps()

    return (
      <Application
        title={t(['title'])}
        name={i18n.trans(['tve', 'title'])}
        navigation={<Navigation data={this.getHandler()} next={this.previousHandler} />}>
        <form onSubmit={this.onSubmit}>
          <BigOptionRadio {...inputSetProps(['customerType'], { label: null })} values={this.customerTypeValues} />
          <NavigationButtons
            nextAction={this.nextHandler}
            previousAction={this.previousHandler}
            order={['previous', 'next']}
            previousProps={{ className: 'atp-show-for-l-down' }}
          />
        </form>
      </Application>
    )
  }
}

export default CustomerType
